const bacterialDiseaseIcd11CodesSet = new Set([
  "$1A07-S",
  "$1B1Z-S",
  "$AB0Z",
  "$CA40.Y",
  "$CA4Z",
  "$I1",
  "$ME05.1-XS25",
  "$ME05.1-XS5W",
  "$ME05.1-XS8H",
  "$O1",
  "$O2",
  "$O3",
  "1A00",
  "1A07",
  "1A07.Z",
  "1A0Z",
  "1A1Z",
  "1A40",
  "1A40.Z",
  "1A6Z",
  "1A70",
  "1A70.0Y",
  "1A72.4",
  "1A7Z",
  "1A8Z",
  "1A90",
  "1A92",
  "1A9Z",
  "1B10",
  "1B10.0",
  "1B10.Z",
  "1B12.6",
  "1B14",
  "1B1Z",
  "1B20.Z",
  "1B21.20",
  "1B50",
  "1B70.Z",
  "1B72",
  "1B72.0",
  "1B75.0",
  "1B75.1",
  "1B75.3",
  "1B7Y",
  "1B93",
  "1B95",
  "1B97",
  "1C12",
  "1C13",
  "1C15",
  "1C17",
  "1C1C.0",
  "1C1D",
  "1C1G",
  "1C23.1",
  "1C23.Y",
  "1C23.Z",
  "1D01.0",
  "1G40",
  "1G41",
  "9A01.20",
  "9A02.0Z",
  "9A60",
  "9A60.0",
  "9A60.3Z",
  "9A60.5",
  "9A60.Y",
  "9A71",
  "9A76",
  "9A77.Z",
  "9A96.Z",
  "9B50",
  "9B51",
  "AA00",
  "AA3Z",
  "AB00",
  "AB01",
  "AB11.0",
  "AB11.1",
  "AB70.0",
  "AB70.2",
  "BB40",
  "CA01",
  "CA02",
  "CA03",
  "CA07.0",
  "CA0A",
  "CA0K.1",
  "CA22",
  "CA23.30",
  "CA24",
  "CA40",
  "CA40.0",
  "DA01.30",
  "DA04.3",
  "DA0B.6",
  "DA0B.Z",
  "DB10",
  "DB70.0",
  "DC12",
  "DC31",
  "DC50",
  "DC50.00",
  "ED80",
  "EE13.1",
  "EK50.0",
  "FA10.Z ",
  "GA00",
  "GA01.Z",
  "GA02",
  "GA04",
  "GA05",
  "GA07.Z",
  "GA91",
  "GB02",
  "GB06.0",
  "GB06.0Y",
  "GB21.0",
  "GB21.Z",
  "GB51",
  "GC02.Z",
  "GC08",
  "GC08.Y",
  "JA43.2",
  "JB40.0",
  "JB40.1",
  "JB40.Z",
  "KA60",
  "KA65.0",
  "MA01",
  "MD31",
  "ME05.1",
  "ME05.1",
  "MF3A",
  "MF58",
  "MG25",
  "MG26",
  "MG26",
  "MG52.00",
  "NE81.2Z",
  "NF0A.3",
  "PA75",
  "PA75.2",
  "PA78",
  "PE14",
  "SC20",
  "XA2UD3",
  "XA7EZ3",
  "XN3DY",
]);

const guidedDiagnosisDiseaseIcd11CodesSet = new Set([
  "1F4Z", // Malaria, confirmed
]);

export const isBacterialDiseaseIcd11Code = (code: string) => {
  return bacterialDiseaseIcd11CodesSet.has(code);
};

export const isGuidedDiagnosisDiseaseIcd11Code = (code: string) => {
  return guidedDiagnosisDiseaseIcd11CodesSet.has(code);
};
